import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _cloneDeep from "lodash/cloneDeep";
import _isEmpty from "lodash/isEmpty";
import _omit from "lodash/omit";
import _groupBy from "lodash/groupBy";
import _map from "lodash/map";
import _isNil from "lodash/isNil";
import _size from "lodash/size";
import _compact from "lodash/compact";
import _uniq from "lodash/uniq";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.object.keys.js";
import dayjs from 'dayjs';
import { getSampleTechMetadataValue, isParseSampleTech, validSampleTechs } from 'const/enums/SampleTech';
import { SAMPLES_CREATED, SAMPLES_ERROR, SAMPLES_SAVED, SAMPLES_SAVING } from 'redux/actionTypes/samples';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { METADATA_DEFAULT_VALUE } from 'redux/reducers/experiments/initialState';
import { defaultSampleOptions, sampleTemplate } from 'redux/reducers/samples/initialState';
import UploadStatus from 'utils/upload/UploadStatus';
import { getKitLabel } from 'utils/secondary-analysis/kitOptions';
import { metadataNameToKey } from 'utils/data-management/metadataUtils';
import { createMetadataTrack, updateValuesInMetadataTrack } from '../experiments';
import bulkUpdateSampleKits from './bulkUpdateSampleKits';

// If the sample name of new samples coincides with already existing
// ones we should not create new samples,
// just reuse their sampleIds and upload the new files
var splitByAlreadyExistingSamples = function splitByAlreadyExistingSamples(newSamples, sampleIds, samples, sampleTechnology, options, kit) {
  var alreadyCreatedSampleIds = {};
  sampleIds.forEach(function (sampleId) {
    var _newSamples$find;
    var _ref = (_newSamples$find = newSamples.find(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          name = _ref4[0];
        return name === samples[sampleId].name;
      })) !== null && _newSamples$find !== void 0 ? _newSamples$find : [],
      _ref2 = _slicedToArray(_ref, 1),
      _ref2$ = _ref2[0],
      repeatedSampleName = _ref2$ === void 0 ? null : _ref2$;
    if (!repeatedSampleName) return;
    alreadyCreatedSampleIds[repeatedSampleName] = sampleId;
  });
  var samplesToCreate = newSamples
  // Upload only the samples that don't have a repeated name
  .filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      name = _ref6[0];
    return !alreadyCreatedSampleIds[name];
  }).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      name = _ref8[0];
    return {
      name: name,
      sampleTechnology: sampleTechnology,
      options: options,
      kit: kit
    };
  });
  return {
    samplesToCreate: samplesToCreate,
    alreadyCreatedSampleIds: alreadyCreatedSampleIds
  };
};

// Metadata tracks labelling each sample with what was selected when it was uploaded.
// They are only added once the samples of a project differ in it.
var technologyMetadataTrack = {
  name: 'Technology',
  getValue: function getValue(sample) {
    return getSampleTechMetadataValue(sample.type);
  }
};
var kitTypeMetadataTrack = {
  name: 'Kit Type',
  // samples of other technologies have no kit
  getValue: function getValue(sample) {
    var _getKitLabel;
    return (_getKitLabel = getKitLabel(sample.kit)) !== null && _getKitLabel !== void 0 ? _getKitLabel : sample.kit;
  }
};
var syncDerivedMetadataTrack = function syncDerivedMetadataTrack(_ref9, experimentId, changedSampleIds) {
  var name = _ref9.name,
    getValue = _ref9.getValue;
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, experiments, samples, _experiments$experime, sampleIds, metadataKeys, key, trackExists, allSamples, differentValues, samplesToUpdate, updates;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), experiments = _getState.experiments, samples = _getState.samples;
            _experiments$experime = experiments[experimentId], sampleIds = _experiments$experime.sampleIds, metadataKeys = _experiments$experime.metadataKeys;
            key = metadataNameToKey(name);
            trackExists = metadataKeys.includes(key);
            allSamples = sampleIds.map(function (sampleId) {
              return samples[sampleId];
            });
            differentValues = _uniq(_compact(allSamples.map(getValue)));
            if (trackExists) {
              _context.next = 11;
              break;
            }
            if (!(_size(differentValues) < 2)) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return");
          case 9:
            _context.next = 11;
            return dispatch(createMetadataTrack(name, experimentId));
          case 11:
            // Once the track exists only the uploaded samples get their value,
            // so edits the user made to the other samples' values are kept
            samplesToUpdate = (trackExists ? changedSampleIds.map(function (sampleId) {
              return samples[sampleId];
            }) : allSamples).filter(function (sample) {
              return !_isNil(getValue(sample)) && sample.metadata[key] !== getValue(sample);
            });
            updates = _map(_groupBy(samplesToUpdate, getValue), function (samplesWithValue, value) {
              return {
                value: value,
                sampleIds: _map(samplesWithValue, 'uuid')
              };
            });
            _context.next = 15;
            return dispatch(updateValuesInMetadataTrack(experimentId, key, updates));
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref0.apply(this, arguments);
    };
  }();
};
var createSamples = function createSamples(experimentId, newSamples, sampleTechnology, selectedParseKit) {
  var ffpeEnabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var experiment, _getState2, samples, createdDate, options, oldSamples, oldSameSampleTech, firstSample, _splitByAlreadyExisti, samplesToCreate, alreadyCreatedSampleIds, sampleIdsChangingKit, url, newSampleIdsByName, sampleIdsByName, newSamplesToRedux, changedSampleIds, errorMessage;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch({
              type: SAMPLES_SAVING,
              payload: {
                message: endUserMessages.SAVING_SAMPLE
              }
            });
            experiment = getState().experiments[experimentId];
            _getState2 = getState(), samples = _getState2.samples;
            createdDate = dayjs().toISOString();
            if (validSampleTechs.has(sampleTechnology)) {
              _context2.next = 6;
              break;
            }
            throw new Error("Sample technology ".concat(sampleTechnology, " is not recognized"));
          case 6:
            options = defaultSampleOptions[sampleTechnology] || {};
            oldSamples = experiment.sampleIds.map(function (sampleId) {
              return samples[sampleId];
            }); // Inherit options from existing samples of the same technology
            oldSameSampleTech = oldSamples.filter(function (sample) {
              return sample.type === sampleTechnology;
            });
            if (oldSameSampleTech.length > 0) {
              firstSample = oldSameSampleTech[0];
              options = _objectSpread({}, firstSample.options);
            }
            if (isParseSampleTech(sampleTechnology)) {
              options = ffpeEnabled ? _objectSpread(_objectSpread({}, options), {}, {
                ffpe: true
              }) : _omit(options, 'ffpe');
            }
            _splitByAlreadyExisti = splitByAlreadyExistingSamples(newSamples, experiment.sampleIds, samples, sampleTechnology, options, selectedParseKit), samplesToCreate = _splitByAlreadyExisti.samplesToCreate, alreadyCreatedSampleIds = _splitByAlreadyExisti.alreadyCreatedSampleIds; // Files of a sample name that already exists are added to that sample,
            // so a Parse sample uploaded again with another kit selected takes that kit
            sampleIdsChangingKit = _isNil(selectedParseKit) ? [] : Object.values(alreadyCreatedSampleIds).filter(function (sampleId) {
              return samples[sampleId].type === sampleTechnology && samples[sampleId].kit !== selectedParseKit;
            });
            if (!(_isEmpty(samplesToCreate) && _isEmpty(sampleIdsChangingKit))) {
              _context2.next = 16;
              break;
            }
            dispatch({
              type: SAMPLES_SAVED
            });
            return _context2.abrupt("return", alreadyCreatedSampleIds);
          case 16:
            url = "/v2/experiments/".concat(experimentId, "/samples");
            _context2.prev = 17;
            if (_isEmpty(sampleIdsChangingKit)) {
              _context2.next = 21;
              break;
            }
            _context2.next = 21;
            return dispatch(bulkUpdateSampleKits(sampleIdsChangingKit, selectedParseKit));
          case 21:
            if (!_isEmpty(samplesToCreate)) {
              _context2.next = 25;
              break;
            }
            _context2.t0 = {};
            _context2.next = 28;
            break;
          case 25:
            _context2.next = 27;
            return fetchAPI(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(samplesToCreate)
            });
          case 27:
            _context2.t0 = _context2.sent;
          case 28:
            newSampleIdsByName = _context2.t0;
            // Join the already existing sampleIds with the new ones,
            // order is preserved in newSamples
            sampleIdsByName = _objectSpread(_objectSpread({}, alreadyCreatedSampleIds), newSampleIdsByName);
            newSamplesToRedux = newSamples
            // Remove repeated samples
            .filter(function (_ref10) {
              var _ref11 = _slicedToArray(_ref10, 1),
                name = _ref11[0];
              return newSampleIdsByName[name];
            }).map(function (_ref12) {
              var _experiment$metadataK;
              var _ref13 = _slicedToArray(_ref12, 2),
                name = _ref13[0],
                files = _ref13[1].files;
              return _objectSpread(_objectSpread({}, _cloneDeep(sampleTemplate)), {}, {
                name: name,
                type: sampleTechnology,
                experimentId: experimentId,
                uuid: sampleIdsByName[name],
                createdDate: createdDate,
                lastModified: createdDate,
                options: options,
                kit: selectedParseKit,
                metadata: (_experiment$metadataK = experiment === null || experiment === void 0 ? void 0 : experiment.metadataKeys.reduce(function (acc, metadataKey) {
                  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, metadataKey, METADATA_DEFAULT_VALUE));
                }, {})) !== null && _experiment$metadataK !== void 0 ? _experiment$metadataK : {},
                files: Object.keys(files).reduce(function (acc, fileType) {
                  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, fileType, {
                    upload: {
                      status: UploadStatus.UPLOADING
                    }
                  }));
                }, {})
              });
            });
            if (!_isEmpty(samplesToCreate)) {
              dispatch({
                type: SAMPLES_CREATED,
                payload: {
                  experimentId: experimentId,
                  samples: newSamplesToRedux
                }
              });
            }
            changedSampleIds = [].concat(_toConsumableArray(Object.values(newSampleIdsByName)), _toConsumableArray(sampleIdsChangingKit));
            _context2.next = 35;
            return dispatch(syncDerivedMetadataTrack(technologyMetadataTrack, experimentId, changedSampleIds));
          case 35:
            _context2.next = 37;
            return dispatch(syncDerivedMetadataTrack(kitTypeMetadataTrack, experimentId, changedSampleIds));
          case 37:
            dispatch({
              type: SAMPLES_SAVED
            });
            return _context2.abrupt("return", sampleIdsByName);
          case 41:
            _context2.prev = 41;
            _context2.t1 = _context2["catch"](17);
            console.error(_context2.t1);
            errorMessage = handleError(_context2.t1, endUserMessages.ERROR_CREATING_SAMPLE);
            dispatch({
              type: SAMPLES_ERROR,
              payload: {
                error: errorMessage
              }
            });

            // throw again the error so `processSampleUpload` won't upload the sample
            throw new Error(errorMessage);
          case 47:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[17, 41]]);
    }));
    return function (_x3, _x4) {
      return _ref1.apply(this, arguments);
    };
  }();
};
export default createSamples;